import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ROLES_REQUEST } from "./types";

interface RolesState {
  allRoles: any | null;
  allPermissions: any | null;
  roleDetails: any | null;
  loading: boolean;
  error: any | null;
}

const rolesInitialState: RolesState = {
  allRoles: null,
  allPermissions: null,
  roleDetails: null,
  loading: false,
  error: null,
};

export const rolesSlice = createSlice({
  name: ROLES_REQUEST,
  initialState: rolesInitialState,
  reducers: {
    roleRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    roleSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.allRoles = action.payload.response;
    },
    roleFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    permissionRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    permissionSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.allPermissions = action.payload.response;
    },
    permissionFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    roleDetailsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    roleDetailsSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.roleDetails = action.payload.response;
    },
    roleDetailsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    resetRoles(state) {
      state.allRoles = null;
    },
  },
});

export const {
  roleRequest,
  roleSuccess,
  roleFailure,
  permissionSuccess,
  permissionFailure,
  permissionRequest,
  roleDetailsRequest,
  roleDetailsSuccess,
  roleDetailsFailure,
  resetRoles,
} = rolesSlice.actions;
export default rolesSlice.reducer;
